export enum SocketEvent {
  JOIN_TEAM = 'join-team',
  LEAVE_TEAM = 'leave-team',
  JOIN_QR_CODE = 'join-qr-code',
  LEAVE_QR_CODE = 'leave-qr-code',
}
